<template>
  <div class="pi-modal" @click.stop>
    <button class="pi-close" @click="$emit('close')" aria-label="Cerrar">
      <i class="fas fa-times"></i>
    </button>

    <div class="pi-header">
      <span class="pi-chip"><i class="fas fa-credit-card"></i> Pagos sin efectivo</span>
      <h2 class="pi-title">Métodos de Pago</h2>
      <p class="pi-subtitle">Realiza tu pago de forma rápida y segura con cualquiera de estas opciones.</p>
    </div>

    <div class="pi-methods">

      <!-- ─── SPEI ─── -->
      <div class="pi-card">
        <div class="pi-card-header pi-card-header--spei">
          <i class="fas fa-building-columns"></i>
          <span>Transferencia SPEI</span>
        </div>
        <div class="pi-card-body">
          <div class="pi-row">
            <span class="pi-label">Banco</span>
            <span class="pi-value">{{ spei.banco }}</span>
          </div>
          <div class="pi-row">
            <span class="pi-label">Titular</span>
            <span class="pi-value">{{ spei.titular }}</span>
          </div>
          <div class="pi-row">
            <span class="pi-label">CLABE</span>
            <div class="pi-copy-row">
              <span class="pi-value pi-mono">{{ spei.clabe }}</span>
              <button class="pi-copy-btn" @click="copy(spei.clabe, 'clabe')" :class="{ copied: copied === 'clabe' }">
                <i :class="copied === 'clabe' ? 'fas fa-check' : 'fas fa-copy'"></i>
                {{ copied === 'clabe' ? 'Copiado' : 'Copiar' }}
              </button>
            </div>
          </div>
          <div class="pi-row" v-if="spei.cuenta">
            <span class="pi-label">Cuenta</span>
            <div class="pi-copy-row">
              <span class="pi-value pi-mono">{{ spei.cuenta }}</span>
              <button class="pi-copy-btn" @click="copy(spei.cuenta, 'cuenta')" :class="{ copied: copied === 'cuenta' }">
                <i :class="copied === 'cuenta' ? 'fas fa-check' : 'fas fa-copy'"></i>
                {{ copied === 'cuenta' ? 'Copiado' : 'Copiar' }}
              </button>
            </div>
          </div>
        </div>
      </div>

      <!-- ─── Mercado Pago ─── -->
      <div class="pi-card" v-if="false">
        <div class="pi-card-header pi-card-header--mp">
          <i class="fas fa-wallet"></i>
          <span>Mercado Pago</span>
        </div>
        <div class="pi-card-body">
          <div class="pi-row" v-if="mp.usuario">
            <span class="pi-label">Usuario</span>
            <div class="pi-copy-row">
              <span class="pi-value pi-mono">{{ mp.usuario }}</span>
              <button class="pi-copy-btn" @click="copy(mp.usuario, 'mpuser')" :class="{ copied: copied === 'mpuser' }">
                <i :class="copied === 'mpuser' ? 'fas fa-check' : 'fas fa-copy'"></i>
                {{ copied === 'mpuser' ? 'Copiado' : 'Copiar' }}
              </button>
            </div>
          </div>
          <p class="pi-mp-desc">Busca nuestro usuario en la app de Mercado Pago o usa el botón para pagar en línea.</p>
          <a v-if="mp.link" :href="mp.link" target="_blank" rel="noopener" class="pi-btn pi-btn--mp">
            <i class="fas fa-arrow-up-right-from-square"></i> Pagar con Mercado Pago
          </a>
          <p class="pi-note"><i class="fas fa-circle-info"></i> El pago se acredita al instante. Guarda tu comprobante.</p>
        </div>
      </div>

      <!-- ─── CoDi ─── -->
      <div class="pi-card" v-if="false">
        <div class="pi-card-header pi-card-header--codi">
          <i class="fas fa-qrcode"></i>
          <span>CoDi / Pago con QR</span>
        </div>
        <div class="pi-card-body pi-card-body--codi">
          <div v-if="codi.qrUrl" class="pi-qr-wrap">
            <img :src="codi.qrUrl" alt="QR CoDi Neliel Papelería" class="pi-qr-img" />
          </div>
          <div v-else class="pi-qr-placeholder">
            <i class="fas fa-qrcode"></i>
            <p>QR próximamente</p>
          </div>
          <p class="pi-codi-steps">
            <strong>¿Cómo pagar?</strong><br>
            1. Abre tu app bancaria<br>
            2. Elige «Pagar con QR» o «CoDi»<br>
            3. Escanea este código<br>
            4. Confirma el monto y envía
          </p>
          <p class="pi-note"><i class="fas fa-circle-info"></i> Compatible con BBVA, Banamex, HSBC, Santander, Banorte y más.</p>
        </div>
      </div>

    </div>

    <div class="pi-footer">
      <i class="fas fa-lock"></i> Tus datos están protegidos. Ante cualquier duda escríbenos a
      <a href="mailto:contacto@neliel.mx">contacto@neliel.mx</a>
    </div>
  </div>
</template>

<script>
// ─── Edita aquí tus datos de pago ────────────────────────────────────────────
const SPEI = {
  banco:   'BBVA',                       // Nombre del banco
  titular: 'Richar Alfredo Salinas Santiago',
  clabe:   '012375004898374421',          // CLABE de 18 dígitos
  cuenta:  '',                           // Número de cuenta (opcional, deja '' para ocultar)
}

const MP = {
  usuario: '@neliel',                    // Usuario de Mercado Pago
  link:    '',                           // Link directo de cobro (opcional)
}

const CODI = {
  qrUrl: '',                             // URL o base64 de la imagen QR (deja '' para placeholder)
}
// ─────────────────────────────────────────────────────────────────────────────

export default {
  name: 'PaymentInfo',
  emits: ['close'],
  data() {
    return {
      spei: SPEI,
      mp:   MP,
      codi: CODI,
      copied: null,
    }
  },
  methods: {
    async copy(text, key) {
      try {
        await navigator.clipboard.writeText(text.replace(/\s/g, ''))
        this.copied = key
        setTimeout(() => { this.copied = null }, 2000)
      } catch {
        // fallback — select text manually
      }
    }
  }
}
</script>

<style scoped>
.pi-modal {
  background: #fff;
  border-radius: 24px;
  width: 100%;
  max-width: 680px;
  max-height: 90vh;
  overflow-y: auto;
  padding: 2.5rem 2.5rem 2rem;
  position: relative;
  font-family: marine, 'Inter', sans-serif;
  scrollbar-width: none;
  -ms-overflow-style: none;
}
.pi-modal::-webkit-scrollbar { display: none; }

.pi-close {
  position: absolute;
  top: 1.25rem; right: 1.25rem;
  background: #f1f5f9;
  border: none;
  width: 34px; height: 34px;
  border-radius: 50%;
  cursor: pointer;
  color: #64748b;
  font-size: 0.9rem;
  display: flex; align-items: center; justify-content: center;
  transition: background 0.15s, color 0.15s;
}
.pi-close:hover { background: #e2e8f0; color: #1a1a1a; }

/* ─── Header ─── */
.pi-header { margin-bottom: 1.75rem; }
.pi-chip {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background: rgba(0,59,76,0.07);
  color: var(--c-primary, #003b4c);
  border: 1px solid rgba(0,59,76,0.12);
  border-radius: 999px;
  padding: 4px 12px;
  font-size: 0.68rem;
  font-weight: 800;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  margin-bottom: 0.75rem;
}
.pi-title {
  font-size: 1.6rem;
  font-weight: 900;
  color: var(--c-primary, #003b4c);
  margin: 0 0 0.4rem;
}
.pi-subtitle { font-size: 0.9rem; color: #64748b; margin: 0; }

/* ─── Cards grid ─── */
.pi-methods {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.pi-card {
  border: 1px solid #e2e8f0;
  border-radius: 16px;
  overflow: hidden;
}

/* Card headers */
.pi-card-header {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 0.875rem 1.25rem;
  font-size: 0.85rem;
  font-weight: 800;
  text-transform: uppercase;
  letter-spacing: 0.06em;
}
.pi-card-header i { font-size: 1.1rem; }

.pi-card-header--spei { background: linear-gradient(135deg, #003b4c 0%, #005f78 100%); color: #fff; }
.pi-card-header--mp   { background: linear-gradient(135deg, #009ee3 0%, #00b1ea 100%); color: #fff; }
.pi-card-header--codi { background: linear-gradient(135deg, #ed8f7b 0%, #f0c2b2 100%); color: #003b4c; }

/* Card body */
.pi-card-body {
  padding: 1.25rem;
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  background: #fafafa;
}

.pi-row {
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.pi-label {
  font-size: 0.65rem;
  font-weight: 800;
  text-transform: uppercase;
  letter-spacing: 0.1em;
  color: #94a3b8;
}
.pi-value {
  font-size: 0.92rem;
  font-weight: 600;
  color: #1e293b;
}
.pi-mono {
  font-family: 'Courier New', monospace;
  font-size: 0.88rem;
  letter-spacing: 0.05em;
  color: var(--c-primary, #003b4c);
}

.pi-copy-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  background: #e8edf2;
  border-radius: 10px;
  padding: 8px 12px;
}
.pi-copy-btn {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  background: var(--c-primary, #003b4c);
  color: #fff;
  border: none;
  border-radius: 999px;
  padding: 5px 12px;
  font-size: 0.72rem;
  font-weight: 700;
  cursor: pointer;
  transition: background 0.15s;
  white-space: nowrap;
  flex-shrink: 0;
  font-family: inherit;
}
.pi-copy-btn:hover { background: #005570; }
.pi-copy-btn.copied { background: #16a34a; }

.pi-note {
  font-size: 0.75rem;
  color: #64748b;
  margin: 0;
  display: flex;
  align-items: flex-start;
  gap: 6px;
  line-height: 1.5;
  background: #f0f9ff;
  border: 1px solid #bae6fd;
  border-radius: 8px;
  padding: 8px 10px;
}
.pi-note i { color: #0284c7; flex-shrink: 0; margin-top: 2px; }

/* Mercado Pago */
.pi-mp-desc { font-size: 0.84rem; color: #475569; margin: 0; }
.pi-btn {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 10px 20px;
  border-radius: 999px;
  font-size: 0.84rem;
  font-weight: 700;
  text-decoration: none;
  transition: all 0.18s;
  align-self: flex-start;
  font-family: inherit;
}
.pi-btn--mp { background: #009ee3; color: #fff; }
.pi-btn--mp:hover { background: #0081c2; transform: translateY(-1px); }

/* CoDi */
.pi-card-body--codi { align-items: center; }
.pi-qr-wrap {
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  padding: 12px;
  display: inline-block;
}
.pi-qr-img { width: 160px; height: 160px; display: block; }
.pi-qr-placeholder {
  width: 160px; height: 160px;
  background: #f1f5f9;
  border: 2px dashed #cbd5e1;
  border-radius: 12px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: #94a3b8;
  gap: 8px;
}
.pi-qr-placeholder i { font-size: 2.5rem; opacity: 0.4; }
.pi-qr-placeholder p { font-size: 0.75rem; margin: 0; font-weight: 600; }
.pi-codi-steps {
  font-size: 0.82rem;
  color: #475569;
  line-height: 1.8;
  margin: 0;
  text-align: center;
}
.pi-codi-steps strong { color: var(--c-primary, #003b4c); }

/* ─── Footer ─── */
.pi-footer {
  margin-top: 1.5rem;
  padding-top: 1rem;
  border-top: 1px solid #f1f5f9;
  font-size: 0.75rem;
  color: #94a3b8;
  display: flex;
  align-items: center;
  gap: 6px;
  flex-wrap: wrap;
}
.pi-footer i { color: #16a34a; }
.pi-footer a { color: var(--c-primary, #003b4c); text-decoration: none; font-weight: 600; }
.pi-footer a:hover { text-decoration: underline; }

/* ─── Mobile ─── */
@media (max-width: 600px) {
  .pi-modal { padding: 1.75rem 1.25rem 1.5rem; border-radius: 16px; }
  .pi-title { font-size: 1.3rem; }
  .pi-copy-row { flex-direction: column; align-items: flex-start; }
  .pi-copy-btn { align-self: flex-start; }
}
</style>
